<template>
  <div>
    <!--
    Was möchten Sie tun?

    1) Hinweis, falls es auf der Reservierung noch *NICHT VERBUCHTE* Leistungen gibt - fragen ob diese verbucht werden sollen?

    * Eine Anzahlung erfassen
      - Umsatzsteuer Anzahlung ?
      - Anzahlung wurde bereits bezahlt
      - Zahlungsanforderung (Online Zahlungslink) erstellen und dem Gast per E-Mail senden
      - Anzahlungsrechnung (Zielrechnung) zur späteren Bezahlung erstellen
        + Wer wird diese Rechnung bezahlen?
        + Rechnungsanmerkung (z.B. Zahlungsziel) hinzufügen?
    * Eine Rechnung über den Aufenthalt erstellen
      - Eine Rechnung für diese Zimmerreservierung erstellen
        + Wer wird diese Rechnung bezahlen?
        + Wird diese Rechnung vor Ort bezahlt oder erst zu einem späteren Zeitpunkt?
        + Möchten Sie eine Zahlungsanforderung erstellen?
        + Rechnung per E-Mail versenden?
      - Eine Rechnung splitten
        + Nächtigungsleistungen aufteilen
        + Einzelne Leistungen auf eine separate Rechnung verschieben
      - Eine Sammelrechnung (mehrere Zimmerreservierung erstellen)
        + Welche Reservierung?
        + Wer wird diese Rechnung bezahlen?
        + Wird diese Rechnung vor Ort bezahlt oder erst zu einem späteren Zeitpunkt?
        + Möchten Sie eine Zahlungsanforderung erstellen?
        + Rechnung per E-Mail versenden?
    * Eine Anzahlung (teilweise) rückerstatten
      - Welche Anzahlung?
      - Auf die ursprüngliche verwendete Zahlungsmethode oder eine andere?
    * Eine Stornogebühr verrechnen
      - Wie hoch ist die Stornogebühr?
      - Restbetrag rückerstatten?
      - Fehlbetrag mittels Zahlungsanforderung per E-Mail einfordern?
    * Gutschein einlösen
      - Eigener Gutschein
        + Mehrzweckgutschein (Beim Verkauf des Gutscheins wurde keine Mehrwertsteuer ausgewiesen)
        + Leistungsgutschein/Einzweckgutschein (Beim Verkauf des Gutscheins wurde die Mehrwertsteuer ausgewiesen)
          ~ Wie hoch war die Mehrwertsteuer/Leistung auswählen
      - Gutschein Drittanbieter (Betrag wird vom Drittanbieter an uns ausbezahlt - d.h. zu behandeln wie Bargeld)
      - Gutscheincode (verpflichtend)


    # Bei bestehender Rechnung
    * Rechnungsadresse korrigieren
    * Zahlung hinzufügen
    * Zahlungsart korrigieren
    * Leistungen und/oder Rechnungsbetrag ändern
    -->
  </div>
</template>

<script>
export default {
  name: 'FolioWizard',
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
@import '~styles/import';
</style>



// WEBPACK FOOTER //
// src/components/lib/folios/FolioWizard.vue